module.exports = __webpack_public_path__ + "static/img/homepage-header-CoreJJ.72612cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/homepage-header-CoreJJ.jpg
// module id = F2I0
// module chunks = 35